// Email Templates
export const GET_EMAIL_TEMPLATES = "/email-templates";
export const ADD_EMAIL_TEMPLATE = "/email-templates";
export const UPDATE_EMAIL_TEMPLATE = "/email-templates";
export const DELETE_EMAIL_TEMPLATE = "/email-templates";
export const SET_DEFAULT_EMAIL_TEMPLATE = "/email-templates";
export const GET_DEFAULT_EMAIL_TEMPLATE = "/email-templates/default";

// Email Send
export const SEND_EMAIL = "/email/send";

// OTP
export const GENERATE_OTP = "/otp/generate";
export const VERIFY_OTP = "/otp/verify";
export const CHECK_OTP = "/otp/check";

// Reminders
export const GET_REMINDERS = "/reminders";
export const SEARCH_REMINDERS = "/reminders/search";
export const ADD_NEW_REMINDER = "/reminders";
export const UPDATE_REMINDER = "/reminders";
export const DELETE_REMINDER = "/reminders";

// Service Visits (Unified Customer + Reminder Creation)
export const CREATE_SERVICE_VISIT = "/service-visits";
export const CHECK_CUSTOMER_BY_PHONE = "/service-visits/check-customer";

//REGISTER
export const POST_FAKE_REGISTER = "/auth/register";

//LOGIN
export const POST_FAKE_LOGIN = "/auth/login";
export const POST_FAKE_LOGIN_REMEMBER_ME = "/auth/login-remember-me";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const POST_RESET_PASSWORD = "/auth/reset-password";
export const SOCIAL_LOGIN = "/social-login";

// Email OTP Authentication (Registration & Forgot Password)
export const SEND_EMAIL_OTP = "/auth/send-email-otp";
export const REGISTER_WITH_EMAIL_OTP = "/auth/register-with-email-otp";
export const SEND_FORGOT_PASSWORD_OTP = "/auth/send-forgot-password-otp";
export const VERIFY_FORGOT_PASSWORD_OTP = "/auth/verify-forgot-password-otp";

// OTP Authentication (Mobile-based signup/login)
export const SEND_OTP_AUTH = "/auth/send-otp";
export const VERIFY_OTP_AUTH = "/auth/verify-otp";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";
export const GET_USER_PROFILE = "/profile/user";
export const UPDATE_USER_PROFILE = "/profile/update";

// User Settings
export const GET_USER_SETTINGS = "/user/settings";
export const UPDATE_USER_SETTINGS = "/user/settings";
export const EXPORT_USER_DATA = "/user/export-data";
export const DELETE_USER_ACCOUNT = "/user/delete-account";

// LeadWix 2.0 — Onboarding & Feature Flags (Phase 0)
export const GET_ONBOARDING_STATUS = "/onboarding/status";
export const COMPLETE_ONBOARDING = "/onboarding/complete";
export const GET_FEATURE_FLAGS = "/feature-flags";

// LeadWix 2.0 — Phase 1 Leads, Pipeline, Widgets
// (LW_ prefix to avoid clash with legacy Velzon /apps/lead constants below)
export const LW_GET_LEADS = "/leads";
export const LW_SEARCH_LEADS = "/leads/search";
export const LW_ADD_LEAD = "/leads";
export const LW_UPDATE_LEAD = "/leads";          // PUT /leads/{id}
export const LW_DELETE_LEAD = "/leads";          // DELETE /leads/{id}
export const LW_CHANGE_LEAD_STAGE = "/leads";    // PATCH /leads/{id}/stage
export const LW_MARK_LEAD_WON = "/leads";        // POST /leads/{id}/won
export const LW_MARK_LEAD_LOST = "/leads";       // POST /leads/{id}/lost
export const LW_LEAD_ACTIVITIES = "/leads";      // GET/POST /leads/{id}/activities
export const GET_PIPELINE_STAGES = "/pipeline/stages";
export const ADD_PIPELINE_STAGE = "/pipeline/stages";
export const UPDATE_PIPELINE_STAGE = "/pipeline/stages";  // PUT /pipeline/stages/{id}
export const DELETE_PIPELINE_STAGE = "/pipeline/stages";  // DELETE /pipeline/stages/{id}
export const GET_WIDGET = "/widgets";                     // GET /widgets/{websiteId}
export const ENABLE_WIDGET = "/widgets";                  // POST /widgets/{websiteId}/enable
export const DISABLE_WIDGET = "/widgets";                 // POST /widgets/{websiteId}/disable
export const UPDATE_WIDGET_CONFIG = "/widgets";           // PUT /widgets/{websiteId}/config
export const REGENERATE_WIDGET_KEY = "/widgets";          // POST /widgets/{websiteId}/regenerate-key

// LeadWix 2.0 — Phase 2 WhatsApp Inbox + Sequences
export const GET_WA_CONVERSATIONS = "/whatsapp/conversations";
export const GET_WA_CONVERSATION_MESSAGES = "/whatsapp/conversations"; // /{id}/messages
export const MARK_WA_CONVERSATION_READ = "/whatsapp/conversations";    // POST /{id}/read
export const REPLY_WA_CONVERSATION = "/whatsapp/conversations";        // POST /{id}/reply
export const GET_SEQUENCES = "/sequences";
export const ADD_SEQUENCE = "/sequences";
export const UPDATE_SEQUENCE = "/sequences";       // PUT /sequences/{id}
export const DELETE_SEQUENCE = "/sequences";       // DELETE /sequences/{id}
export const ENROLL_SEQUENCE = "/sequences";       // POST /sequences/{id}/enroll
export const UNENROLL_SEQUENCE = "/sequences/enrollments"; // DELETE /sequences/enrollments/{id}
export const GET_LEAD_ENROLLMENTS = "/sequences/leads";    // GET /sequences/leads/{leadId}/enrollments

// LeadWix 2.0 — Phase 3 Wisp AI
export const AI_DRAFT_REPLY = "/ai/conversations";   // POST /ai/conversations/{id}/draft
export const AI_LEAD_SUMMARY = "/ai/leads";          // GET  /ai/leads/{id}/summary
export const AI_LEAD_SCORE   = "/ai/leads";          // POST /ai/leads/{id}/score
export const AI_QUOTA        = "/ai/quota";
export const AI_CONSENT      = "/ai/consent";
export const AI_WHATSAPP_DRAFT = "/ai/whatsapp/draft";   // POST  body: { phone }
export const AI_LEAD_SCORE_EXPLAIN = "/leads";           // GET  /leads/{id}/score-explanation
export const LEAD_IMPORT_DEDUP = "/leads/import/check-duplicates"; // POST { candidates: [...] }

// LeadWix 2.0 — Phase 5 Affiliate
export const AFFILIATE_DASHBOARD = "/affiliate/dashboard";

// Calendar
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMMINGEVENT = "/upcommingevents";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

// Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";
export const DELETE_MESSAGE = "delete/message";

//Mailbox
export const GET_MAIL_DETAILS = "/mail";
export const DELETE_MAIL = "/delete/mail";

// Ecommerce
// Product
export const GET_PRODUCTS = "/apps/product";
export const DELETE_PRODUCT = "/apps/product";
export const ADD_NEW_PRODUCT = "/apps/product";
export const UPDATE_PRODUCT = "/apps/product";

// Orders
export const GET_ORDERS = "/apps/order";
export const ADD_NEW_ORDER = "/apps/order";
export const UPDATE_ORDER = "/apps/order";
export const DELETE_ORDER = "/apps/order";

// Customers
export const GET_CUSTOMERS = "/customers";
export const SEARCH_CUSTOMERS = "/customers/search";
export const ADD_NEW_CUSTOMER = "/apps/customer";
export const UPDATE_CUSTOMER = "/apps/customer";
export const DELETE_CUSTOMER = "/apps/customer";

// Sellers
export const GET_SELLERS = "/sellers";

// Project list
export const GET_PROJECT_LIST = "/project/list";

// Task
export const GET_TASK_LIST = "/apps/task";
export const ADD_NEW_TASK = "/apps/task";
export const UPDATE_TASK = "/apps/task";
export const DELETE_TASK = "/apps/task";

// CRM
// Conatct
export const GET_CONTACTS = "/apps/contact";
export const ADD_NEW_CONTACT = "/apps/contact";
export const UPDATE_CONTACT = "/apps/contact";
export const DELETE_CONTACT = "/apps/contact";

// Companies
export const GET_COMPANIES = "/apps/company";
export const ADD_NEW_COMPANIES = "/apps/company";
export const UPDATE_COMPANIES = "/apps/company";
export const DELETE_COMPANIES = "/apps/company";

// Lead
export const GET_LEADS = "/apps/lead";
export const ADD_NEW_LEAD = "/apps/lead";
export const UPDATE_LEAD = "/apps/lead";
export const DELETE_LEAD = "/apps/lead";

// Deals
export const GET_DEALS = "/deals";

// Crypto
export const GET_TRANSACTION_LIST = "/transaction-list";
export const GET_ORDRER_LIST = "/order-list";

// Invoice
export const GET_INVOICES = "/apps/invoice";
export const ADD_NEW_INVOICE = "/apps/invoice";
export const UPDATE_INVOICE = "/apps/invoice";
export const DELETE_INVOICE = "/apps/invoice";
export const MARK_INVOICE_SENT = "/apps/invoice";
export const MARK_INVOICE_PAID = "/apps/invoice";
export const GENERATE_INVOICE_PDF = "/apps/invoice";
export const SEND_INVOICE_EMAIL = "/apps/invoice";

// UPI Payment
export const GENERATE_UPI_LINK_INVOICE = "/payment/upi/invoice";
export const GENERATE_UPI_LINK_PLAN = "/payment/upi/plan";
export const MARK_INVOICE_PAID_UPI = "/payment/mark-paid";

// TicketsList
export const GET_TICKETS_LIST = "/apps/ticket";
export const ADD_NEW_TICKET = "/apps/ticket";
export const UPDATE_TICKET = "/apps/ticket";
export const DELETE_TICKET = "/apps/ticket";

// Dashboard Analytics

// Sessions by Countries
export const GET_ALL_DATA = "/all-data";
export const GET_HALFYEARLY_DATA = "/halfyearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

// Audiences Metrics
export const GET_ALLAUDIENCESMETRICS_DATA = "/allAudiencesMetrics-data";
export const GET_MONTHLYAUDIENCESMETRICS_DATA = "/monthlyAudiencesMetrics-data";
export const GET_HALFYEARLYAUDIENCESMETRICS_DATA = "/halfyearlyAudiencesMetrics-data";
export const GET_YEARLYAUDIENCESMETRICS_DATA = "/yearlyAudiencesMetrics-data";

// Users by Device
export const GET_TODAYDEVICE_DATA = "/todayDevice-data";
export const GET_LASTWEEKDEVICE_DATA = "/lastWeekDevice-data";
export const GET_LASTMONTHDEVICE_DATA = "/lastMonthDevice-data";
export const GET_CURRENTYEARDEVICE_DATA = "/currentYearDevice-data";

// Audiences Sessions by Country
export const GET_TODAYSESSION_DATA = "/todaySession-data";
export const GET_LASTWEEKSESSION_DATA = "/lastWeekSession-data";
export const GET_LASTMONTHSESSION_DATA = "/lastMonthSession-data";
export const GET_CURRENTYEARSESSION_DATA = "/currentYearSession-data";

// Dashboard CRM

// Balance Overview
export const GET_TODAYBALANCE_DATA = "/todayBalance-data";
export const GET_LASTWEEKBALANCE_DATA = "/lastWeekBalance-data";
export const GET_LASTMONTHBALANCE_DATA = "/lastMonthBalance-data";
export const GET_CURRENTYEARBALANCE_DATA = "/currentYearBalance-data";

// Deal type
export const GET_TODAYDEAL_DATA = "/todayDeal-data";
export const GET_WEEKLYDEAL_DATA = "/weeklyDeal-data";
export const GET_MONTHLYDEAL_DATA = "/monthlyDeal-data";
export const GET_YEARLYDEAL_DATA = "/yearlyDeal-data";

// Sales Forecast

export const GET_OCTSALES_DATA = "/octSales-data";
export const GET_NOVSALES_DATA = "/novSales-data";
export const GET_DECSALES_DATA = "/decSales-data";
export const GET_JANSALES_DATA = "/janSales-data";

// Dashboard Ecommerce
// Revenue
export const GET_ALLREVENUE_DATA = "/allRevenue-data";
export const GET_MONTHREVENUE_DATA = "/monthRevenue-data";
export const GET_HALFYEARREVENUE_DATA = "/halfYearRevenue-data";
export const GET_YEARREVENUE_DATA = "/yearRevenue-data";

// Dashboard Crypto
// Portfolio
export const GET_BTCPORTFOLIO_DATA = "/btcPortfolio-data";
export const GET_USDPORTFOLIO_DATA = "/usdPortfolio-data";
export const GET_EUROPORTFOLIO_DATA = "/euroPortfolio-data";

// Market Graph
export const GET_ALLMARKETDATA_DATA = "/allMarket-data";
export const GET_YEARMARKET_DATA = "/yearMarket-data";
export const GET_MONTHMARKET_DATA = "/monthMarket-data";
export const GET_WEEKMARKET_DATA = "/weekMarket-data";
export const GET_HOURMARKET_DATA = "/hourMarket-data";

// Dashboard Crypto
// Project Overview
export const GET_ALLPROJECT_DATA = "/allProject-data";
export const GET_MONTHPROJECT_DATA = "/monthProject-data";
export const GET_HALFYEARPROJECT_DATA = "/halfYearProject-data";
export const GET_YEARPROJECT_DATA = "/yearProject-data";

// Project Status
export const GET_ALLPROJECTSTATUS_DATA = "/allProjectStatus-data";
export const GET_WEEKPROJECTSTATUS_DATA = "/weekProjectStatus-data";
export const GET_MONTHPROJECTSTATUS_DATA = "/monthProjectStatus-data";
export const GET_QUARTERPROJECTSTATUS_DATA = "/quarterProjectStatus-data";

// Dashboard NFT
// Marketplace
export const GET_ALLMARKETPLACE_DATA = "/allMarketplace-data";
export const GET_MONTHMARKETPLACE_DATA = "/monthMarketplace-data";
export const GET_HALFYEARMARKETPLACE_DATA = "/halfYearMarketplace-data";
export const GET_YEARMARKETPLACE_DATA = "/yearMarketplace-data";

// Project
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

// Pages > Team
export const GET_TEAMDATA = "/teamData";
export const DELETE_TEAMDATA = "/delete/teamData";
export const ADD_NEW_TEAMDATA = "/add/teamData";
export const UPDATE_TEAMDATA = "/update/teamData";

// File Manager
// Folder
export const GET_FOLDERS = "/folder";
export const DELETE_FOLDER = "/delete/folder";
export const ADD_NEW_FOLDER = "/add/folder";
export const UPDATE_FOLDER = "/update/folder";

// File
export const GET_FILES = "/file";
export const DELETE_FILE = "/delete/file";
export const ADD_NEW_FILE = "/add/file";
export const UPDATE_FILE = "/update/file";

// To do
export const GET_TODOS = "/todo";
export const DELETE_TODO = "/delete/todo";
export const ADD_NEW_TODO = "/add/todo";
export const UPDATE_TODO = "/update/todo";

// To do Project
export const GET_PROJECTS = "/projects";
export const ADD_NEW_TODO_PROJECT = "/add/project";

//JOB APPLICATION
export const GET_APPLICATION_LIST = "/application-list";

//JOB APPLICATION
export const GET_API_KEY = "/api-key";

// kanban
export const GET_TASKS = "/apps/tasks";
export const ADD_TASKS = "/add/tasks";
export const UPDATE_TASKS = "/update/tasks";
export const DELETE_TASKS = "/delete/tasks";

// Support / Help
export const SUBMIT_CONTACT_FORM = "/support/contact";

// Channel Usage Tracking
export const TRACK_CHANNEL_USAGE = "/channel-usage/track";

// Push Notifications (Web Push / VAPID)
export const GET_VAPID_PUBLIC_KEY     = "/push/vapid-public-key";
export const SUBSCRIBE_PUSH           = "/push/subscribe";
export const UNSUBSCRIBE_PUSH         = "/push/unsubscribe";
export const SEND_TEST_PUSH           = "/push/test";

// Professional Tasks (multi-profession extension)
export const CREATE_PROFESSIONAL_TASK     = "/professional-tasks";
export const GET_PROFESSIONAL_TASKS       = "/professional-tasks";
export const GET_TODAYS_PROFESSIONAL_TASKS = "/professional-tasks/today";
export const MARK_PROFESSIONAL_TASK_DONE  = "/professional-tasks"; // + /{id}/done
export const DELETE_PROFESSIONAL_TASK     = "/professional-tasks"; // + /{id}
// WhatsApp Credits
export const GET_WHATSAPP_CREDITS         = "/whatsapp/credits";
export const CREATE_WHATSAPP_CREDIT_ORDER = "/whatsapp/create-credit-order";
export const VERIFY_WHATSAPP_CREDITS      = "/whatsapp/verify-credits";
export const GET_WHATSAPP_USAGE           = "/whatsapp/usage";

// AI Website Builder
export const GET_WEBSITE_TEMPLATES     = "/websites/public/templates";
export const CHECK_WEBSITE_SLUG        = "/websites/public/check-slug";
export const CREATE_WEBSITE            = "/websites";
export const QUICK_PUBLISH_WEBSITE     = "/websites/quick-publish";
export const GET_USER_WEBSITES         = "/websites";
export const GET_WEBSITE               = "/websites";          // + /{id}
export const GENERATE_WEBSITE_CONTENT  = "/websites";          // + /{id}/generate
export const UPDATE_WEBSITE_CONTENT    = "/websites";          // + /{id}/content
export const UPDATE_WEBSITE_TEMPLATE   = "/websites";          // + /{id}/template
export const EDIT_WEBSITE              = "/websites";          // + /{id}/edit
export const PUBLISH_WEBSITE           = "/websites";          // + /{id}/publish
export const WEBSITE_PAYMENT_COMPLETE  = "/websites";          // + /{id}/payment-complete
export const GET_WEBSITE_LEADS         = "/websites";          // + /{id}/leads
export const DELETE_WEBSITE            = "/websites";          // + /{id}
